<template>
<loader v-bind="{ loading }">
  <form>
    <select-input
      required
      :items="availableAttributeTypes"
      :value="builder.scrapable_id"
      @input="setScrapable"
      value-key="id"
      label-key="title">
      Attribute Type
    </select-input>

    <div v-if="activeScraper" class="mt-2">
      <component 
        :is="`scraper-builder-${activeScraper.scraper.key}`"
        :scraper="activeScraper"
      />
    </div>

  </form>
</loader>  
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { find } from 'lodash'

export default {
  
  data: () => ({
    loading: true
  }),

  created() {
    Promise.all([
      this.$store.dispatch('attributeType/loadAttributeTypeList'),
      this.$store.dispatch('scraper/loadScraperList'),
    ]).then(() => {
      this.loading = false
    })
  },

  beforeDestroy() {
    this.clear()
  },

  methods: {
    ...mapMutations('scraperBuilder', [
      'clear'
    ]),
    setScrapable(id) {
      const attributeType = this.getAttributeType(id)
      this.$store.commit('attributeType/setAttributeType', attributeType)
      this.$store.commit('scraperBuilder/setScrapable', {
        id,
        scrapable_type: 'attribute_type',
        type: attributeType.type,
        handler: this.activeScraper.scraper
      })
    },
    getAttributeType(id) {
      return find(this.availableAttributeTypes, type => type.id === id)
    }
  },

  computed: {
    ...mapGetters('scraper', [
      'scraperList'
    ]),
    ...mapGetters('scraperBuilder', [
      'builder'
    ]),
    ...mapGetters('attributeType', [
      'attributeTypeList',
      'attributeType'
    ]),
    availableAttributeTypes() {
      return this.attributeTypeList
    },
    activeScraper() {
      if (!this.attributeType || !this.attributeType.id) return null
      return this.scraperList.find(scraper => scraper.scraper.key === this.attributeType.type)
    }
  }

}
</script>